module.exports = __webpack_public_path__ + "img/figure01.fe1653ae.png";